import {httpUrl} from './httpUrl'

let baseUrl = `${httpUrl.host}/gy-apartment`

let api = {
  // 查询金额配置分页
  getPayRecordPage: `${baseUrl}/payRecord/getPage`,

  // 导出缴费记录
  exportPayRecord: `${baseUrl}/payRecord/export`,

  // 获取支付宝账户列表
  getAliAccountList: `${baseUrl}/aliAccount/getList`,

  // 修改收款账户信息
  updatePaySetting: `${baseUrl}/paySetting/update`,

  // 获取收款账户信息
  getPaySettingList: `${baseUrl}/paySetting/getPaySettingList`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/PayService.js